<template>
    <header class="bg-white shadow">
        <div class="container mx-auto py-6">
            <div class=" row items-center">
                <div v-if="$slots.heading" class="col-full sm:col">
                    <h1 class="text-xl font-bold leading-tight text-gray-900 sm:text-3xl">
                            <span class="block text-gray-400 text-xs">
                                <slot name="section">&nbsp;</slot>
                            </span>
                        <slot name="heading"/>
                    </h1>
                    <slot name="underHeading"></slot>
                </div>
                <div v-if="$slots.links" class="col-full mt-2 sm:col-auto sm:mt-0">
                    <slot name="links"/>
                </div>
            </div>
        </div>
    </header>
    <div class="flex-auto bg-gray-50">
        <div class="container mx-auto py-6">

            <Breadcrumbs v-if="breadcrumbs && breadcrumbs.length" :links="breadcrumbs" class="mb-4"/>

            <slot></slot>
        </div>
    </div>
</template>

<script>

import Breadcrumbs from "@/Components/Breadcrumbs";

export default {

    name: "AdminPageInner",

    props: {
        breadcrumbs: {
            type: Array,
            default: () => ([])
        }
    },

    components: {
        Breadcrumbs
    }
};

</script>
